<template>
  <v-form v-model="valid" ref="mainForm">
    <opq-catalogue code="situation" v-model="sasEtudiantCandidat.statutDemandeur" :live="liveSasEtudiantCandidat(1926)"></opq-catalogue>

    <v-divider v-if="estEtudiant" class="mb-6"></v-divider>

    <opq-catalogue
      :opq-if="estEtudiant"
      code="universite"
      v-model="sasEtudiantCandidat.universite"
      :live="liveSasEtudiantCandidat(1927)"
    ></opq-catalogue>

    <opq-text-field
      code="autre-universite"
      v-model="sasEtudiantCandidat.autreUniversite"
      :live="liveSasEtudiantCandidat(1928)"
      :opq-if="estAutreUniversite"
    ></opq-text-field>

    <opq-text-field
      :opq-if="estEtudiant"
      code="code-permanent"
      v-model="sasEtudiantCandidat.codePermanent"
      :live="liveSasEtudiantCandidat(1940)"
    ></opq-text-field>

    <opq-catalogue
      :opq-if="estEtudiant"
      code="concentration"
      v-model="sasEtudiantCandidat.concentration"
      :live="liveSasEtudiantCandidat(1929)"
    ></opq-catalogue>

    <opq-text-field
      code="autre-concentration"
      :opq-if="estAutreConcentration"
      v-model="sasEtudiantCandidat.autreConcentration"
      :live="liveSasEtudiantCandidat(1930)"
    ></opq-text-field>

    <opq-text-field
      :opq-if="estEtudiant"
      code="niveau-universitaire"
      v-model="sasEtudiantCandidat.niveau"
      is-number
      width="75"
      :live="liveSasEtudiantCandidat(1933)"
    ></opq-text-field>

    <opq-date-picker
      :opq-if="estEtudiant"
      code="date-fin-etude"
      hide-day
      v-model="sasEtudiantCandidat.dateFinEtudeEnvisagee"
      :live="liveSasEtudiantCandidat(1931)"
    ></opq-date-picker>

    <opq-text-field
      :opq-if="estEtudiant"
      code="heures-stage"
      v-model="sasEtudiantCandidat.nombreHeuresStage"
      is-number
      width="100"
      :live="liveSasEtudiantCandidat(1932)"
    ></opq-text-field>

    <opq-text-field
      :opq-if="estEtudiant"
      code="heures-internat"
      v-model="sasEtudiantCandidat.nombreHeuresInternat"
      is-number
      width="100"
      :live="liveSasEtudiantCandidat(1934)"
    ></opq-text-field>

    <opq-file
      :opq-if="estEtudiant"
      code="attestation-heures"
      :live="liveSasEtudiantCandidat(1935)"
      :file="sasEtudiantCandidat.attestationHeuresFormations"
    ></opq-file>
    <opq-file
      :opq-if="estEtudiant"
      code="attestation-etudes"
      :live="liveSasEtudiantCandidat(1936)"
      :file="sasEtudiantCandidat.attestationHeuresEtudes"
    ></opq-file>
  </v-form>
</template>

<script>
import CataloguesHelper from "@/mixins/CataloguesHelpers"
import FormSimple from "@/mixins/FormSimple"
export default {
  mixins: [CataloguesHelper, FormSimple],
  props: {
    sas: { type: Object }
  },

  computed: {
    sasEtudiantCandidat() {
      return this.sas.sasEtudiantCandidat
    },

    estEtudiant() {
      return this.sasEtudiantCandidat.statutDemandeur == "R1EpL3pBVKbydyyG8kh2xR1EpL41tMUAR1EpL1R1EpL1"
    },
    estCandidat() {
      return this.sasEtudiantCandidat.statutDemandeur == "FHIR1EpL4nMIdR1EpL4sTTEXvTGkb0dAR1EpL1R1EpL1"
    },
    estAutreUniversite() {
      return this.getCatalogueCodeById(4906, this.sasEtudiantCandidat.universite) == "autre"
    },
    estAutreConcentration() {
      return this.getCatalogueCodeById(1929, this.sasEtudiantCandidat.concentration) == "autre"
    }
  },
  methods: {
    liveSasEtudiantCandidat(cle) {
      return { endpoint: "/sas-etudiant-candidat/", cle: cle, fileId: this.sasEtudiantCandidat.id }
    }
  }
}
</script>

<style>
</style>